<template>
  <div class="container" v-bind="loading()">
    <div class="row">
      <div class="col col s12 m12 xl12">
        <div class="card">
          <div class="card-image">
            <img :src="ObjDish[dishId].img" class="hide-on-med-and-up">
            <img
              :src="ObjDish[dishId].img"
              class="hide-on-small-only materialboxed"
              :data-caption="ObjDish[dishId].name"
            >
            <div class="toscew">
              <span class="card-title activator red-text text-darken-4 tosunscew">
                <div class="bubbles">
                  <h4>{{ObjDish[dishId].name}}</h4>
                </div>
              </span>
            </div>
            <a
              class="btn-floating halfway-fab waves-effect waves-light red darken-4 activator pulse"
            >
              <i class="material-icons right">more_vert</i>
            </a>
          </div>
          <div class="card-content">
            <ul class="tabs">
              <li class="tab col s6 m6 l6 xl6">
                <a href="#IngredientsDish">
                  <span class="tab-icon-material-text">Ingredientes</span>
                </a>
              </li>
              <li class="tab col s6 m6 l6 xl6">
                <a href="#CommentsDish">
                  <span class="tab-icon-material tab-icon-material-text">Comentarios</span>
                </a>
              </li>
            </ul>
          </div>
          <div class="card-reveal">
            <span class="card-title red-text text-darken-4">
              {{ObjDish[dishId].name}}
              <i class="material-icons right">restaurant_menu</i>
            </span>
            <span class="grey-text">
              <span class="clasificacion" v-if="ObjDish[dishId].star > 4.5">
                <input type="radio" value="5" checked>
                <label>&#9733;</label>
                <input type="radio" value="4">
                <label>&#9733;</label>
                <input type="radio" value="3">
                <label>&#9733;</label>
                <input type="radio" value="2">
                <label>&#9733;</label>
                <input type="radio" value="1">
                <label>&#9733;</label>
              </span>
              <span class="clasificacion" v-else-if="ObjDish[dishId].star > 3.5 && ObjDish[dishId].star <= 4.5">
                <input type="radio" value="5">
                <label>&#9733;</label>
                <input type="radio" value="4" checked>
                <label>&#9733;</label>
                <input type="radio" value="3">
                <label>&#9733;</label>
                <input type="radio" value="2">
                <label>&#9733;</label>
                <input type="radio" value="1">
                <label>&#9733;</label>
              </span>
              
              <span class="clasificacion" v-else-if="ObjDish[dishId].star > 2.5 && ObjDish[dishId].star < 3.5">
                <input type="radio" value="5">
                <label>&#9733;</label>
                <input type="radio" value="4">
                <label>&#9733;</label>
                <input type="radio" value="3" checked>
                <label>&#9733;</label>
                <input type="radio" value="2">
                <label>&#9733;</label>
                <input type="radio" value="1">
                <label>&#9733;</label>
              </span>
              <span class="clasificacion" v-else-if="ObjDish[dishId].star > 1.5 && ObjDish[dishId].star < 2.5">
                <input type="radio" value="5">
                <label>&#9733;</label>
                <input type="radio" value="4">
                <label>&#9733;</label>
                <input type="radio" value="3">
                <label>&#9733;</label>
                <input type="radio" value="2" checked>
                <label>&#9733;</label>
                <input type="radio" value="1">
                <label>&#9733;</label>
              </span>
              <span class="clasificacion" v-else-if="ObjDish[dishId].star > 0.5 && ObjDish[dishId].star < 1.5">
                <input type="radio" value="5">
                <label>&#9733;</label>
                <input type="radio" value="4">
                <label>&#9733;</label>
                <input type="radio" value="3">
                <label>&#9733;</label>
                <input type="radio" value="2">
                <label>&#9733;</label>
                <input type="radio" value="1" checked>
                <label>&#9733;</label>
              </span>
              <span class="clasificacion" v-else-if="ObjDish[dishId].star < 0.5">
                <input type="radio" value="5">
                <label>&#9733;</label>
                <input type="radio" value="4">
                <label>&#9733;</label>
                <input type="radio" value="3">
                <label>&#9733;</label>
                <input type="radio" value="2">
                <label>&#9733;</label>
                <input type="radio" value="1">
                <label>&#9733;</label>
              </span>
              Calificación: {{ObjDish[dishId].star}} - {{ObjDish[dishId].votos}} Votos
            </span>
            <div class="divider"></div>
            {{ObjDish[dishId].desc_max}}
            <br><br>
            Calificar:
            <a
              onclick="M.toast({html: 'Calificación Realizada'})"
              class="clasificacion ">
                <input type="radio" value="5">
                <label>&#9733;</label>
                <input type="radio" value="4">
                <label>&#9733;</label>
                <input type="radio" value="3">
                <label>&#9733;</label>
                <input type="radio" value="2">
                <label>&#9733;</label>
                <input type="radio" value="1">
                <label>&#9733;</label>
            </a>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <Comments></Comments>
      <Ingredients v-bind:Obj="ObjDish[dishId]"></Ingredients>
    </div>
  </div>
</template>
<script>
import Comments from "./CommentsDish";
import Ingredients from "./IngredientsDish";
import BubblesCss from "../../assets/style/bubble.css";
import Star from "../../assets/style/star.css";

export default {
  name: "InfoDish",
  //props:['cateringId','dishId'],
  components: {
    Comments,
    Ingredients
  },
  data() {
    return {
      dishId: "",
      ObjDish: [
        {
          fecha: "20-01-2019",
          code: 1,
          name: "Tortitas o Pancakes americanos",
          desc_min:
            "Tortitas o pancakes. Desayuno muy abundante, pueden incluir también zumos, café, huevos fritos, tostadas, mermeladas…",
          desc_max:
            "Hay pocas cosas más americanas que un desayuno con tortitas o pancakes. Las perfectas escenas familiares se suceden en torno a un desayuno muy abundante, en el que no faltan opciones caseras y potentes que pueden incluir también zumos, café, huevos fritos, tostadas, mermeladas…",
          ingredientes:
            "<ul class='collapsible' style='margin-top: 0px !important;'><li class='collection-item'><i class='material-icons'>whatshot</i>150 gr de harina de trigo.</li><li class='collection-item'><i class='material-icons'>whatshot</i>1 cucharada sopera de azúcar.</li><li class='collection-item'><i class='material-icons'>whatshot</i>8 gr de levadura en polvo o impulsor químico (aproximadamente una cucharada sopera).</li><li class='collection-item'><i class='material-icons'>whatshot</i>1 pizca de sal.</li><li class='collection-item'><i class='material-icons'>whatshot</i>200 ml de leche (1 vaso).</li><li class='collection-item'><i class='material-icons'>whatshot</i>1 huevo.</li><li class='collection-item'><i class='material-icons'>whatshot</i>1 cucharadita de postre de mantequilla.</li></ul>",
          img: require("../../assets/menus/breakfasts/breakfasts_1.jpg"),
          icon: "school",
          star: 3.7,
          votos: 2.459,
          Comments: [
            {
              fecha: "20-01-2019",
              user: "MrDaza",
              email: "mr.daza@ingenieros.com",
              comments: "Buenos",
              star: 3
            }
          ]
        },
        {
          fecha: "20-01-2019",
          code: 2,
          name: "Huevos revueltos con bacon",
          desc_min:
            "Un desayuno al más puro estilo inglés, de esos que puedes permitirte los fines de semana y que hacen que empieces el día con una sonrisa y mucha energía. Me encanta preparar huevos revueltos con bacon, y acompañarlos con unas tostaditas de pan con cereales y zumo de naranja recién exprimido. La única “complicación” de esta receta es que da la sensación de que deberías hacerlo todo a la vez: los huevos para que se mantengan jugosos y calientes, el bacon crujiente y el zumo recién exprimido, pero bueno, iremos paso a paso.",
          desc_max:
            "Un desayuno al más puro estilo inglés, de esos que puedes permitirte los fines de semana y que hacen que empieces el día con una sonrisa y mucha energía. Me encanta preparar huevos revueltos con bacon, y acompañarlos con unas tostaditas de pan con cereales y zumo de naranja recién exprimido. La única “complicación” de esta receta es que da la sensación de que deberías hacerlo todo a la vez: los huevos para que se mantengan jugosos y calientes, el bacon crujiente y el zumo recién exprimido, pero bueno, iremos paso a paso.",
          ingredientes:
            "<ul class='collapsible' style='margin-top: 0px !important;'><li class='collection-item'><i class='material-icons'>whatshot</i>3 huevos frescos tamaño L.</li><li class='collection-item'><i class='material-icons'>whatshot</i>2 cucharadas soperas de leche.</li><li class='collection-item'><i class='material-icons'>whatshot</i>Aceite de semillas y sal.</li><li class='collection-item'><i class='material-icons'>whatshot</i>4 lonchas de bacon.</li></ul>",
          img: require("../../assets/menus/breakfasts/breakfasts_2.jpg"),
          icon: "school",
          star: 3.4,
          votos: 2.459,
          Comments: [
            {
              fecha: "20-01-2019",
              user: "MrDaza",
              email: "mr.daza@ingenieros.com",
              comments: "Buenos",
              star: 3
            }
          ]
        },
        {
          fecha: "20-01-2019",
          code: 3,
          name: "Tortilla de patatas",
          desc_min:
            "Tortilla de patatas o también conocida como tortilla española.",
          desc_max:
            "Hay muchas recetas de la gastronomía española que se conocen de forma internacional pero sin duda la más popular es la tortilla de patatas o también conocida como tortilla española.",
          ingredientes: "",
          img: require("../../assets/menus/breakfasts/breakfasts_3.jpg"),
          icon: "school",
          star: 2.3,
          votos: 2.459,
          Comments: [
            {
              fecha: "20-01-2019",
              user: "MrDaza",
              email: "mr.daza@ingenieros.com",
              comments: "Buenos",
              star: 3
            }
          ]
        },
        {
          fecha: "20-01-2019",
          code: 4,
          name: "Omelette con Espinacas a la carta",
          desc_min: "¡Este Omelette con Espinacas seguro te va a encantar!",
          desc_max:
            "Plato para dos, que además es muy fácil de preparar, es una excelente opción para preparar un desayuno rápido y muy saludable. ¡Este Omelette con Espinacas seguro te va a encantar!",
          ingredientes:
            "<ul class='collapsible' style='margin-top: 0px !important;'><li class='collection-item'><i class='material-icons'>whatshot</i>4 huevos</li><li class='collection-item'><i class='material-icons'>whatshot</i>2 tajadas de queso</li><li class='collection-item'><i class='material-icons'>whatshot</i>1 taza de espinacas</li><li class='collection-item'><i class='material-icons'>whatshot</i>Mantequilla</li><li class='collection-item'><i class='material-icons'>whatshot</i>Sal</li></ul>",
          img: require("../../assets/menus/breakfasts/breakfasts_4.jpg"),
          icon: "school",
          star: 4.3,
          votos: 2.459,
          Comments: [
            {
              fecha: "20-01-2019",
              user: "MrDaza",
              email: "mr.daza@ingenieros.com",
              comments: "Buenos",
              star: 3
            }
          ]
        },
        {
          fecha: "20-01-2019",
          code: 5,
          name: "Tortitas o Pancakes americanos",
          desc_min:
            "Tortitas o pancakes. Desayuno muy abundante, pueden incluir también zumos, café, huevos fritos, tostadas, mermeladas…",
          desc_max:
            "Hay pocas cosas más americanas que un desayuno con tortitas o pancakes. Las perfectas escenas familiares se suceden en torno a un desayuno muy abundante, en el que no faltan opciones caseras y potentes que pueden incluir también zumos, café, huevos fritos, tostadas, mermeladas…",
          ingredientes:
            "<ul class='collapsible' style='margin-top: 0px !important;'><li class='collection-item'><i class='material-icons'>whatshot</i>150 gr de harina de trigo.</li><li class='collection-item'><i class='material-icons'>whatshot</i>1 cucharada sopera de azúcar.</li><li class='collection-item'><i class='material-icons'>whatshot</i>8 gr de levadura en polvo o impulsor químico (aproximadamente una cucharada sopera).</li><li class='collection-item'><i class='material-icons'>whatshot</i>1 pizca de sal.</li><li class='collection-item'><i class='material-icons'>whatshot</i>200 ml de leche (1 vaso).</li><li class='collection-item'><i class='material-icons'>whatshot</i>1 huevo.</li><li class='collection-item'><i class='material-icons'>whatshot</i>1 cucharadita de postre de mantequilla.</li></ul>",
          img: require("../../assets/menus/breakfasts/breakfasts_1.jpg"),
          icon: "school",
          star: 3.7,
          votos: 2.459,
          Comments: [
            {
              fecha: "20-01-2019",
              user: "MrDaza",
              email: "mr.daza@ingenieros.com",
              comments: "Buenos",
              star: 3
            }
          ]
        },
        {
          fecha: "20-01-2019",
          code: 6,
          name: "Huevos revueltos con bacon",
          desc_min:
            "Un desayuno al más puro estilo inglés, de esos que puedes permitirte los fines de semana y que hacen que empieces el día con una sonrisa y mucha energía. Me encanta preparar huevos revueltos con bacon, y acompañarlos con unas tostaditas de pan con cereales y zumo de naranja recién exprimido. La única “complicación” de esta receta es que da la sensación de que deberías hacerlo todo a la vez: los huevos para que se mantengan jugosos y calientes, el bacon crujiente y el zumo recién exprimido, pero bueno, iremos paso a paso.",
          desc_max:
            "Un desayuno al más puro estilo inglés, de esos que puedes permitirte los fines de semana y que hacen que empieces el día con una sonrisa y mucha energía. Me encanta preparar huevos revueltos con bacon, y acompañarlos con unas tostaditas de pan con cereales y zumo de naranja recién exprimido. La única “complicación” de esta receta es que da la sensación de que deberías hacerlo todo a la vez: los huevos para que se mantengan jugosos y calientes, el bacon crujiente y el zumo recién exprimido, pero bueno, iremos paso a paso.",
          ingredientes:
            "<ul class='collapsible' style='margin-top: 0px !important;'><li class='collection-item'><i class='material-icons'>whatshot</i>3 huevos frescos tamaño L.</li><li class='collection-item'><i class='material-icons'>whatshot</i>2 cucharadas soperas de leche.</li><li class='collection-item'><i class='material-icons'>whatshot</i>Aceite de semillas y sal.</li><li class='collection-item'><i class='material-icons'>whatshot</i>4 lonchas de bacon.</li></ul>",
          img: require("../../assets/menus/breakfasts/breakfasts_2.jpg"),
          icon: "school",
          star: 3.4,
          votos: 2.459,
          Comments: [
            {
              fecha: "20-01-2019",
              user: "MrDaza",
              email: "mr.daza@ingenieros.com",
              comments: "Buenos",
              star: 3
            }
          ]
        },
        {
          fecha: "20-01-2019",
          code: 7,
          name: "Tortilla de patatas",
          desc_min:
            "Tortilla de patatas o también conocida como tortilla española.",
          desc_max:
            "Hay muchas recetas de la gastronomía española que se conocen de forma internacional pero sin duda la más popular es la tortilla de patatas o también conocida como tortilla española.",
          ingredientes: "",
          img: require("../../assets/menus/breakfasts/breakfasts_3.jpg"),
          icon: "school",
          star: 2.3,
          votos: 2.459,
          Comments: [
            {
              fecha: "20-01-2019",
              user: "MrDaza",
              email: "mr.daza@ingenieros.com",
              comments: "Buenos",
              star: 3
            }
          ]
        },
        {
          fecha: "20-01-2019",
          code: 8,
          name: "Omelette con Espinacas  a la piedra",
          desc_min: "¡Este Omelette con Espinacas seguro te va a encantar!",
          desc_max:
            "PLato para dos, que además es muy fácil de preparar, es una excelente opción para preparar un desayuno rápido y muy saludable. ¡Este Omelette con Espinacas seguro te va a encantar!",
          ingredientes:
            "<ul class='collapsible' style='margin-top: 0px !important;'><li class='collection-item'><i class='material-icons'>whatshot</i>4 huevos</li><li class='collection-item'><i class='material-icons'>whatshot</i>2 tajadas de queso</li><li class='collection-item'><i class='material-icons'>whatshot</i>1 taza de espinacas</li><li class='collection-item'><i class='material-icons'>whatshot</i>Mantequilla</li><li class='collection-item'><i class='material-icons'>whatshot</i>Sal</li></ul>",
          img: require("../../assets/menus/breakfasts/breakfasts_4.jpg"),
          icon: "school",
          star: 4.3,
          votos: 2.459,
          Comments: [
            {
              fecha: "20-01-2019",
              user: "MrDaza",
              email: "mr.daza@ingenieros.com",
              comments: "Buenos",
              star: 3
            }
          ]
        },
        {
          fecha: "20-01-2019",
          code: 9,
          name: "Cazuela Cremosa de Pasta y Queso",
          desc_min:
            "Cheesy Creamy Pasta Casserole is as delicious and almost as easy as your traditional mac and cheese! The difference? An additional touch of nutritious vegetables mixed in a variety of melted cheeses. Dare to serve your family something different!",
          desc_max:
            "¡Cheesy Creamy Pasta Casserole es tan deliciosa y casi tan fácil como tu mac y queso tradicionales! ¿La diferencia? Un toque adicional de vegetales nutritivos mezclados en una variedad de quesos fundidos. ¡Atrévete a servir a tu familia algo diferente!",
          ingredientes:
            "<ul class='collapsible' style='margin-top: 0px !important;'><li class='collection-item'><i class='material-icons'>whatshot</i>150 gr de harina de trigo.</li><li class='collection-item'><i class='material-icons'>whatshot</i>1 cucharada sopera de azúcar.</li><li class='collection-item'><i class='material-icons'>whatshot</i>8 gr de levadura en polvo o impulsor químico (aproximadamente una cucharada sopera).</li><li class='collection-item'><i class='material-icons'>whatshot</i>1 pizca de sal.</li><li class='collection-item'><i class='material-icons'>whatshot</i>200 ml de leche (1 vaso).</li><li class='collection-item'><i class='material-icons'>whatshot</i>1 huevo.</li><li class='collection-item'><i class='material-icons'>whatshot</i>1 cucharadita de postre de mantequilla.</li></ul>",
          img: require("../../assets/menus/dinners/dinners_9.jpg"),
          icon: "school",
          star: 3.7,
          votos: 2.459,
          Comments: [
            {
              fecha: "20-01-2019",
              user: "MrDaza",
              email: "mr.daza@ingenieros.com",
              comments: "Buenos",
              star: 3
            }
          ]
        },
        {
          fecha: "20-01-2019",
          code: 10,
          name: "Huevos revueltos con bacon",
          desc_min:
            "Un desayuno al más puro estilo inglés, de esos que puedes permitirte los fines de semana y que hacen que empieces el día con una sonrisa y mucha energía. Me encanta preparar huevos revueltos con bacon, y acompañarlos con unas tostaditas de pan con cereales y zumo de naranja recién exprimido. La única “complicación” de esta receta es que da la sensación de que deberías hacerlo todo a la vez: los huevos para que se mantengan jugosos y calientes, el bacon crujiente y el zumo recién exprimido, pero bueno, iremos paso a paso.",
          desc_max:
            "Un desayuno al más puro estilo inglés, de esos que puedes permitirte los fines de semana y que hacen que empieces el día con una sonrisa y mucha energía. Me encanta preparar huevos revueltos con bacon, y acompañarlos con unas tostaditas de pan con cereales y zumo de naranja recién exprimido. La única “complicación” de esta receta es que da la sensación de que deberías hacerlo todo a la vez: los huevos para que se mantengan jugosos y calientes, el bacon crujiente y el zumo recién exprimido, pero bueno, iremos paso a paso.",
          ingredientes:
            "<ul class='collapsible' style='margin-top: 0px !important;'><li class='collection-item'><i class='material-icons'>whatshot</i><i class='material-icons'>whatshot</i>3 huevos frescos tamaño L.</li><li class='collection-item'><i class='material-icons'>whatshot</i>2 cucharadas soperas de leche.</li><li class='collection-item'><i class='material-icons'>whatshot</i>Aceite de semillas y sal.</li><li class='collection-item'><i class='material-icons'>whatshot</i>4 lonchas de bacon.</li></ul>",
          img: require("../../assets/menus/breakfasts/breakfasts_2.jpg"),
          icon: "school",
          star: 3.4,
          votos: 2.459,
          Comments: [
            {
              fecha: "20-01-2019",
              user: "MrDaza",
              email: "mr.daza@ingenieros.com",
              comments: "Buenos",
              star: 3
            }
          ]
        },
        {
          fecha: "20-01-2019",
          code: 11,
          name: "Tortilla de patatas",
          desc_min:
            "Tortilla de patatas o también conocida como tortilla española.",
          desc_max:
            "Hay muchas recetas de la gastronomía española que se conocen de forma internacional pero sin duda la más popular es la tortilla de patatas o también conocida como tortilla española.",
          ingredientes: "",
          img: require("../../assets/menus/breakfasts/breakfasts_3.jpg"),
          icon: "school",
          star: 2.3,
          votos: 2.459,
          Comments: [
            {
              fecha: "20-01-2019",
              user: "MrDaza",
              email: "mr.daza@ingenieros.com",
              comments: "Buenos",
              star: 3
            }
          ]
        },
        {
          fecha: "20-01-2019",
          code: 12,
          name: "Omelette con Espinacas",
          desc_min: "¡Este Omelette con Espinacas seguro te va a encantar!",
          desc_max:
            "PLato para dos, que además es muy fácil de preparar, es una excelente opción para preparar un desayuno rápido y muy saludable. ¡Este Omelette con Espinacas seguro te va a encantar!",
          ingredientes:
            "<ul class='collapsible' style='margin-top: 0px !important;'><li class='collection-item'><i class='material-icons'>whatshot</i>4 huevos</li><li class='collection-item'><i class='material-icons'>whatshot</i>2 tajadas de queso</li><li class='collection-item'><i class='material-icons'>whatshot</i>1 taza de espinacas</li><li class='collection-item'><i class='material-icons'>whatshot</i>Mantequilla</li><li class='collection-item'><i class='material-icons'>whatshot</i>Sal</li></ul>",
          img: require("../../assets/menus/breakfasts/breakfasts_4.jpg"),
          icon: "school",
          star: 4.3,
          votos: 2.459,
          Comments: [
            {
              fecha: "20-01-2019",
              user: "MrDaza",
              email: "mr.daza@ingenieros.com",
              comments: "Buenos",
              star: 3
            }
          ]
        }
      ]
    };
  },
  methods: {
    loading() {
      //this.cateringId = this.$route.params.cateringId;
      if (
        this.$route.params.dishId === undefined ||
        this.$route.params.dishId === null
      ) {
        this.dishId = 0;
      } else {
        this.dishId = this.$route.params.dishId;
      }

      $(document).ready(function() {
        $(".tabs").tabs();
        $(".materialboxed").materialbox();
      });
    }
  }
};
</script>

<style scoped lang="css">
.container {
  width: 100% !important;
}
.row {
  margin-bottom: 0px !important;
}
.row .col {
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding: 0 0 0 0 !important;
  min-height: 1px;
}
.card {
  margin: 0 0 0 0 !important;
}
.card .card-content {
  padding: 0px !important;
}
.tab-icon-material-icon {
  position: absolute;
  top: 25%;
}

.tab-icon-material-text {
  margin: 0px 0px 0px 30px;
}

.tabs .tab a:hover,
.tabs .tab a.active {
  background-color: transparent;
  color: #ffffff !important;
  background-color: #f05545 !important;
}
.tabs .tab a {
  background-color: transparent;
  color: #f05545 !important;
  background-color: #f4f4f5 !important;
}

/* Si [el ancho del dispositivo] es menor o igual a 600px , entonces {…} */
@media only screen and (max-width: 600px) {
  .card {
    min-height: 300px !important;
  }
  .card-image {
    max-height: 275px !important;
  }
  img {
    background-size: cover;
    max-height: 320px !important;
    min-height: 320px !important;
  }
  /* Diagonal Slanting */
  .toscew {
    background-color: #57505766;
    position: absolute;
    top: 180px;
    left: 0px;
    right: 0px;
    height: 110px;
    -ms-transform: skewY(4deg); /* IE 9 */
    -webkit-transform: skewY(4deg); /* Safari */
    transform: skewY(4deg);
  }
  .tosunscew {
    -ms-transform: skewY(-4deg); /* IE 9 */
    -webkit-transform: skewY(-4deg); /* Safari */
    transform: skewY(-4deg);
    color: white;
  }
  h4 {
    text-shadow: 3px 3px 5px #f00 !important;
    font-size: 30px !important;
    color: white !important;
  }
}

/*"Si [el ancho del dispositivo] es mayor o igual a 601px , entonces {…}" */
@media only screen and (min-width: 601px) {
  .card .card-image img {
    border: 1px solid #f6f6f6;
    padding: 25px;
    width: 450px;
    background-repeat: no-repeat;
    background-size: auto;
  }
  /* Diagonal Slanting */
  .toscew {
    background-color: #57505766;
    position: absolute;
    top: 200px;
    left: 0px;
    right: 0px;
    height: 165px;
    -ms-transform: skewY(4deg); /* IE 9 */
    -webkit-transform: skewY(4deg); /* Safari */
    transform: skewY(4deg);
  }
  .tosunscew {
    -ms-transform: skewY(-4deg); /* IE 9 */
    -webkit-transform: skewY(-4deg); /* Safari */
    transform: skewY(-4deg);
    color: white;
  }
  h4 {
    text-shadow: 3px 3px 5px #f00 !important;
    font-size: 30px !important;
    color: white !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/dish/InfoDish.vue